import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalGifts } from '../../../../../../../../selectors/buyPackageModal';
import { pluralDays, formatMoney } from '../../../../../../../../utils/string';
import { GiftIcon } from './components/GiftIcon';
import { TableSeparator } from '../TableSeparator';
import { TableCell } from '../TableCell';
import * as styles from './Gifts.css';

interface IGiftsContainerProps {
  durationCol: boolean;
  auctionPointsCol: boolean;
}

export const GiftsContainer = (props: IGiftsContainerProps) => {
  const { durationCol, auctionPointsCol } = props;
  const gifts = useSelector(selectBuyPackageModalGifts);

  if (!Array.isArray(gifts) || gifts.length === 0) {
    return null;
  }

  return (
    <tbody>
      <TableSeparator />

      {gifts.map((gift, key) => (
        <tr key={key}>
          <TableCell>
            <div className={styles['service_wrapper']}>
              {gift.icon && <GiftIcon name={gift.icon} />}

              <div className={styles['service_name']}>
                <UIText2 color="black_100" display="inline">
                  {gift.name}
                </UIText2>
                &nbsp;
                <UIText2 color="gray40_100" display="inline">
                  ({gift.count})
                </UIText2>
              </div>
            </div>
          </TableCell>

          {durationCol && <TableCell>{pluralDays(gift.durationInDays)}</TableCell>}

          {auctionPointsCol && <TableCell>–</TableCell>}

          <TableCell>
            <UIText2 color="error_100">{formatMoney(0)}</UIText2>
          </TableCell>
        </tr>
      ))}
    </tbody>
  );
};
